import { createAction } from "@reduxjs/toolkit";
import type { LocalStorageEntry } from "common/utilities/browser/localStorage/localStorage";

/** Loaded from localStorage */
export const newItem = createAction("localStorage/newItem", (item: LocalStorageEntry<unknown>) => ({
  payload: {
    item,
  },
}));

/** Persist to localStorage */
export const saveItem = createAction("localStorage/saveItem", (item: LocalStorageEntry<unknown>) => ({
  payload: {
    item,
  },
}));
